// eslint-disable-next-line strict
var Swiper = require('swiper/bundle'); // .default;// .esm.browser.bundle
var isMobile = $(window).width() < 768;

var defaultBreakPoints = {
    breakpoints: {
        // when window width is >= 320px
        320: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        // when window width is >= 480px
        480: {
            slidesPerView: 3,
            spaceBetween: 30,
        },
        // when window width is >= 640px
        640: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
    },
};

/**
 * function used to create slider for explore our boxes section
 */
function initHomePageBannerSlider() {
    var $sliderDOMElm = $('.home-page-banner-slider');
    if ($sliderDOMElm.length > 0) {
        var swiperInitialState = {
            pagination: {
                el: '.home-page-banner-slider .swiper-pagination',
                type: isMobile ? 'bullets' : 'fraction',
            },
            navigation: {
                nextEl: '.home-page-banner-slider .swiper-button-next',
                prevEl: '.home-page-banner-slider .swiper-button-prev',
            },
            scrollbar: {
                el: '.home-page-banner-slider.swiper-scrollbar',
            },
            autoplay: {
                delay: 8000,
            },
            on: {
                reachEnd: function () {
                    // Stop autoplay when the last slide is reached
                    this.autoplay.stop();
                },
            },
        };

		new Swiper.default('.home-page-banner-slider', swiperInitialState); // eslint-disable-line
    }
}

/**
 * function used to create slider for explore our boxes section
 */
function initAllSlider() {
    var $sliderDOMElm = $('.all-slider');
    // const offsetPercentage = ($(window).width() - 1320) / 2;
    const offsetPercentage = 0;
    if ($sliderDOMElm.length > 0) {
        $sliderDOMElm.each(function (e) {
            var $this = $(this);

            $this.addClass('allPageSlider-' + e);
            var breakpoints = $this.data('breakpoints');
            var direction = $this.data('sliderdirectionmobile');
            var isLoop = $this.data('is-loop');
            var swiperInitialState = {
                pagination: {
                    el: '.allPageSlider-' + e + ' .swiper-pagination',
                    type: isMobile ? 'bullets' : 'fraction',
                },
                navigation: {
                    nextEl: '.allPageSlider-' + e + ' .swiper-button-next',
                    prevEl: '.allPageSlider-' + e + ' .swiper-button-prev',
                },
                scrollbar: {
                    el: '.allPageSlider-' + e + ' .swiper-scrollbar',
                },
                // Default parameters
                slidesPerView: 1,
                spaceBetween: 0,
                loop: isLoop,
            };

            if (typeof breakpoints !== 'undefined' && breakpoints !== null) {
                swiperInitialState.breakpoints = breakpoints;
            } else {
                swiperInitialState.breakpoints = defaultBreakPoints.breakpoints;
            }

            if (isMobile) {
                swiperInitialState.calculateHeight = false;
                swiperInitialState.spaceBetween = 20;
                swiperInitialState.direction = direction || 'horizontal';
            } else {
                swiperInitialState.slidesOffsetBefore = offsetPercentage;
            }

            if (direction !== 'vertical') {
                new Swiper.default(
                    '.allPageSlider-' + e + '.all-slider',
                    swiperInitialState
				); // eslint-disable-line
            }
        });
    }
}

/**
 * function used to create slider for explore our boxes section
 */
function initRibbonCarousel() {
    var $sliderDOMElm = $('.ribbon-carousel');

    $sliderDOMElm.slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
    });

    $sliderDOMElm.on('afterChange', function (event, slick, currentSlide) {
        // Check if the current slide is the last slide
        if (currentSlide === slick.slideCount - 1) {
            $sliderDOMElm.slick('slickPause');
        }
    });

    // Handle slick arrows manually to allow navigation after autoplay stops
    $('.ribbon-carousel .slick-prev, .ribbon-carousel .slick-next').on(
        'click',
        function () {
            $sliderDOMElm.slick('slickPlay');
        }
    );
}

/**
 * function used to inititalize the find your swiper
 */
function initRecommendedSlider() {
    var $brandingSection = $('.product-recommendation-listing');
    if ($brandingSection.length > 0) {
        $('.pdp-carousel').each(function (e) {
            var $this = $(this);
            $this.addClass('remondedPDPSlider-' + e);

            var swiperInitialState = {
                spaceBetween: 30,
                loop: true,
                navigation: {
                    nextEl: '.remondedPDPSlider-' + e + ' .swiper-button-next',
                    prevEl: '.remondedPDPSlider-' + e + ' .swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 'auto',
                        spaceBetween: 0,
                        loop: false,
                    },
                    767: {
                        slidesPerView: 2,
                        spaceBetween: 25,
                        loop: true,
                    },
                    940: {
                        slidesPerView: 5,
                        spaceBetween: 20,
                        loop: true,
                    },
                },
            };

            new Swiper.default(
                '.remondedPDPSlider-' + e + ' .product-recommendation-listing',
                swiperInitialState
			); // eslint-disable-line
        });
    }
}

/**
 * function used to create slider for explore our boxes section
 */
function initMinicartRecommendationSlider() {
    $('body').on('minicart:loadRecommendation', function () {
        var $miniCartRecommendation = $('.mini-cart-recommendation-slider-js');
        if ($miniCartRecommendation.length > 0) {
            var swiperInitialState = {
                pagination: {
                    el: '.mini-cart-recommendation-slider-js .swiper-pagination',
                },
                navigation: {
                    nextEl: '.mini-cart-recommendation-slider-js .swiper-button-next',
                    prevEl: '.mini-cart-recommendation-slider-js .swiper-button-prev',
                },
                scrollbar: {
                    el: '.mini-cart-recommendation-slider-js.swiper-scrollbar',
                },
                // Default parameters
                slidesPerView: 1,
                spaceBetween: 10,
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 320px
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    // when window width is >= 480px
                    480: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    // when window width is >= 640px
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                },
            };

            new Swiper.default(
                '.mini-cart-recommendation-slider-js',
                swiperInitialState
			); // eslint-disable-line
        }
    });
}

/**
 * function triggeres einstein carousel
 */
function initEinsteinCarousel() {
    $('body').on('carousel:setup', function () {
        var $domElm = $('.einstein-carousel');
        if ($domElm.length) {
            $domElm.each(function (e) {
                var $this = $(this);
                $this.addClass('einstein-custom-' + e);
                var dataSlideSM = $this.data('sm') || 3;
                var dataSlideXS = $this.data('xs') || 2;
                var dataSlideMS = $this.data('md') || 4;
                var swiperInitialState = {
                    pagination: {
                        el: '.einstein-custom-' + e + ' .swiper-pagination',
                    },
                    navigation: {
                        nextEl: '.einstein-custom-' + e + ' .swiper-button-next',
                        prevEl: '.einstein-custom-' + e + ' .swiper-button-prev',
                    },
                    scrollbar: {
                        el: '.einstein-custom-' + e + '.swiper-scrollbar',
                    },
                    // Default parameters
                    slidesPerView: 1,
                    spaceBetween: 10,
                    // Responsive breakpoints
                    breakpoints: {
                        // when window width is >= 320px
                        320: {
                            slidesPerView: dataSlideXS,
                            spaceBetween: 20,
                        },
                        // when window width is >= 480px
                        480: {
                            slidesPerView: dataSlideSM,
                            spaceBetween: 10,
                        },
                        // when window width is >= 640px
                        640: {
                            slidesPerView: dataSlideMS,
                            spaceBetween: 0,
                        },
                    },
                };

				new Swiper.default('.einstein-custom-' + e, swiperInitialState); // eslint-disable-line
            });
        }
    });
}

/**
 * function triggeres initbannerTiles
 */
function initbannerTiles() {
    /* Slick needs no get Reinitialized on window Resize after it was destroyed */
    $(window).on('load resize orientationchange', function () {
        $('.slick-wrapper-js').each(function () {
            var $carousel = $(this);
            /* Initializes a slick carousel only on mobile screens */
            // slick on mobile
            if ($(window).width() > 768) {
                if ($carousel.hasClass('slick-initialized')) {
                    $carousel.slick('unslick');
                }
            } else if (!$carousel.hasClass('slick-initialized')) {
                $carousel.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    infinite: true,
                    mobileFirst: true,
                    autoplay: true,
                    autoplaySpeed: 2000,
                });
            }
        });
    });
}

module.exports = {
    initHomePageBannerSlider: initHomePageBannerSlider,
    initAllSlider: initAllSlider,
    initRibbonCarousel: initRibbonCarousel,
    initRecommendedSlider: initRecommendedSlider,
    initMinicartRecommendationSlider: initMinicartRecommendationSlider,
    initEinsteinCarousel: initEinsteinCarousel,
    initbannerTiles: initbannerTiles,
};
